//todo this whole employment history feature, all of it, it isn't used

import * as React from "react"

import {SingleBox as Select} from "../../../lib/sbhtml/select"

export type Company = {
	companyId: number
	companyName: string
}

export type CompanySelectorProps = {
	selectorId: string  // if a number of these controls are rendered
	selectedId: number
	companies: Company[]
	onSelectorChange:(selectorId:string, company:Company|undefined) => void
}

// TODO alanb company list structure better as a hash?
export const CompanySelector = (props:CompanySelectorProps) => {
	const options = props.companies.map((company) =>
		<option key={`company-${company.companyId}`} value={company.companyId.toString()}>
			{company.companyName}
		</option>
	)

	const onChange = (value:string) =>
		props.onSelectorChange(
			props.selectorId,
			props.companies.find((company) => company.companyId == Number(value))
		)

	return (
		<Select
			onChange={onChange}
			value={props.selectedId.toString()}
			name={`${props.selectorId}CompanySelector`}
		>
			<option key={'company-0'} value={'0'} />
			{options}
		</Select>
	)
}



// WEBPACK FOOTER //
// ./src/contacts/employmentHistory/components/companySelector.tsx